import React, { useState } from 'react';
import { Modal, Button, Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import {
  Code,
  Row,
  ToolWrapper,
  ComponentWrapper,
} from './styles';

const ComponentWithSource = (props) => {
  const {
    Component,
    source,
  } = props;

  const [isOpen, setOpen] = useState(false);

  return (
    <div>
      <Row>
        <ComponentWrapper>
          {Component}
        </ComponentWrapper>
        <ToolWrapper>
          <Button
            icon
            onClick={() => setOpen(true)}
          >
            <Icon name="code" />
          </Button>
        </ToolWrapper>
      </Row>
      <Modal
        open={isOpen}
        onClose={() => setOpen(false)}
      >
        <Code>{source}</Code>
      </Modal>
    </div>
  );
};

ComponentWithSource.propTypes = {
  Component: PropTypes.node.isRequired,
  source: PropTypes.string.isRequired,
};

export default ComponentWithSource;
